import FileImporter from "./steps/FileImporter";
import Mapper from "./steps/MatchHeader";
import Confirm from "./steps/Confirm";
import Table from "../../../services/table";
import ImportService from "../service/Import";
import TableDataParser from "../../../Helper/TableDataParser";
import { TableManger, COLUMN_CODE, TABLES } from "../../../managers/TableManger";
import { generateUpdatedRecordsFile } from "../utility/SystemFileUpload";
import { excludedColumnCodes } from "../EximConstants";
import { EXCLUDE_STEPPER_HEADER } from "../../../constants/Constant";

export default class StepsManager {
  static getQueryParam(location, param) {
    if (location?.search && param) {
      const query = new URLSearchParams(location.search);
      return query.get(param);
    }

    return null;
  }

  static getColumns(tableName, state) {
    /* Todo: need an identifier for importable columns */
    let columns = [];

    switch (tableName) {
        case "employee":
            columns = state.mapping;
            break;
        case TABLES.CANDIDATE:
            columns = TableManger.getTableImportColumns(tableName, excludedColumnCodes)?.filter(c => c.type !== "file");

            columns.forEach((c) => {
                if (c.columnCode === "email") {
                    c.required = true;
                }
            });
            break;
        case TABLES.ATTENDANCE:
            columns = state.mapping;
            break;
        case TABLES.PEOPLE_COMPONENT:
            columns = state.mapping;
            break;
        default:
            columns = TableManger.getTableImportColumns(
              tableName,
              excludedColumnCodes
            );
            // columns.sort((col1, col2) => col1.name.localeCompare(col2.name));
            break;
    }

    return columns;
  }

  static setTableColumns(tableName) {
    const tableId = TableManger.getTableId(tableName);
    return Table.getTable(tableId).then((data) => {
      TableManger.setTableColumns(data, tableName);
    });
  }

  static createNewColumn(data, tableName) {
    if (!data.name || !data.type)
      return Promise.reject("Please provide valid field name & type");

    const tableId = TableManger.getTableId(tableName);
    const columnData = TableDataParser.getColumnToAdd(data);

    return Table.addColumn(columnData, tableId).then((response) => ({
      id: response.id,
      columnData,
    }));
  }

  static getSegmentColumn(tableName, jobPipelines) {
    let columns = [];
    if (tableName !== "employee") {
        const columnCode = COLUMN_CODE.CANDIDATE.JOBOPENING;
        columns = TableManger.getColumn(tableName, columnCode);

        if (jobPipelines?.length > 0) {
            jobPipelines.forEach((jp) => {
                const index = columns?.options?.findIndex((o) => o.id === jp.id);
                if (index === -1) {
                    columns?.options?.push(jp);
                }
            });
        }
    }

    return columns;
  }

  static async getUploadFileRelativeURL(file) {
    const fileUploadResponse = await ImportService.getUploadFileURL(
      file,
      "IMPORT_PEOPLE_CANDIDATE"
    );
    return fileUploadResponse.relativePath;
  }

  static async uploadNewFile(content, fileName, fileType) {
    const csvFile = await generateUpdatedRecordsFile(
      content,
      fileName,
      fileType
    );
    const filePath = await StepsManager.getUploadFileRelativeURL(csvFile);
    return filePath;
  }

  static uploadRecords(data, tableName) {
    const isJobOpeingExisit =  data?.segmentId?.find(seg=> typeof seg === 'number')
    const dataInsight = {
      dateFormat: "YYYY-MM-DD",
      segmentId: isJobOpeingExisit ? data.segmentId : [1, ...data.segmentId],
      jobStageId: data.jobStageId || [],
    };

    data.properties.forEach((importProp) => {
      dataInsight[importProp.payloadKey] = importProp.selectedOption;
    });

    const mapping = data.headers
      .filter((header) => header.dkColKey !== "0")
      .map((header) => ({
        colHeader: header.importedKey,
        displayName: header.selectedOption,
        fieldName: header.dkColKey,
      }));

    const payload = {
      dataInsight,
      mapping,
    };

    const queryParams = {
      tableId: TableManger.getTableId(tableName),
      module: "PEOPLE_CANDIDATE",
      relativeFilePath: data.filePath,
      auditLogId: data.auditLogId,
    };

    return ImportService.uploadRecords(queryParams, payload);
  }

  static async generateAuditLog(file) {
    const filePath = await StepsManager.getUploadFileRelativeURL(file);
    const auditResponse = await ImportService.saveAuditLog({
      relativePath: filePath,
      module: "PEOPLE_CANDIDATE",
    });

    return auditResponse.id;
  }

  static getAllCreationSteps(onClickHandler) {
    return [
      {
        title: "Upload File",
        requiredProps: [],
        reqError: "Please upload a file to continue",
        getChild: (props) => (
          <FileImporter
            generateAuditLog={StepsManager.generateAuditLog}
            fileInfo={props.state.fileInfo}
            setData={props.setData}
            tableName={props.tableName}
          />
        ),
        onClick: (event) => onClickHandler(event, 0),
      },

      {
        title: "Map Columns",
        requiredProps: ["fileContent"],
        reqError: "Please map/skip the unmapped columns to continue",
        getChild: (props) => (
          <Mapper
            {...props.state}
            setData={props.setData}
            tableName={props.tableName}
            generateNewColumn={StepsManager.createNewColumn}
            setTableColumns={StepsManager.setTableColumns}
            systemHeaders={StepsManager.getColumns(props.tableName)}
          />
        ),
        onClick: (event) => onClickHandler(event, 1),
      },
      {
        title: "Confirm Import",
        requiredProps: ["mappedHeaders"],
        reqError: "Please provide data for required columns",
        getChild: (props) => (
          <Confirm
            {...props.state}
            setData={props.setData}
            backStepHandler={(e) => onClickHandler(e, 1)}
            confirmationHandler={(e) => onClickHandler(e, 3)}
            segmentValues={StepsManager.getSegmentColumn(
              props.tableName,
              props.state.jobPipelines
            )}
            tableColumns={StepsManager.getColumns(props.tableName)}
          />
        ),
        onClick: (event) => onClickHandler(event, 2),
      },
    ];
  }

  static isStepperHeaderActionsAllowed(type) {
    return !EXCLUDE_STEPPER_HEADER.some(x=> x=== type);
  }
}
